// extracted by mini-css-extract-plugin
module.exports = {"pa":"pa-module--pa--gWELe","pa_header":"pa-module--pa_header--2bEZy","pa_body":"pa-module--pa_body--3uDfW","primary_color":"pa-module--primary_color--2pfSd"};